import { type FC, useMemo } from 'react'
import { Center, Flex, type FlexProps, HStack } from '@chakra-ui/react'
import { type TopNavPanelItem } from 'ecosystem'
import { ContentContainer, GrandNextLink, GrandText, UIIcons } from '../../common'
import { useUIGlobalsContext } from '../../lib/ui-globals/hooks'

const PanelItem = ({ item: { icon, href, label } }: { item: TopNavPanelItem }) => {
  const Icon = useMemo(() => (icon && UIIcons[icon]) || (() => null), [icon])

  return (
    <Center flex={1}>
      <HStack
        {...(href
          ? {
              as: GrandNextLink,
              'aria-label': label,
              href
            }
          : {})}
      >
        {!!icon && (
          <Flex fontSize="xs">
            <Icon />
          </Flex>
        )}

        <GrandText fontSize="xs" isTruncated w="auto">
          {label}
        </GrandText>
      </HStack>
    </Center>
  )
}

export interface PanelProps extends FlexProps {
  panelItems: TopNavPanelItem[]
}

const Panel: FC<PanelProps> = ({ panelItems, ...props }) => {
  const { menuMaxContentWidth } = useUIGlobalsContext()

  return (
    <Flex
      bg="var(--chakra-colors-component-TopNavPanel-root-background, var(--chakra-colors-brand-darkGrey))"
      fontSize={{
        base: 'xs',
        md: 'sm'
      }}
      px={{
        base: 2,
        md: 10
      }}
      w="100%"
      {...props}
    >
      <ContentContainer
        color="var(--chakra-colors-component-TopNavPanel-root-color, var(--chakra-colors-text-light))"
        p={0}
        maxW={menuMaxContentWidth}
      >
        {panelItems.map((item) => (
          <PanelItem item={item} key={item.label} />
        ))}
      </ContentContainer>
    </Flex>
  )
}

export default Panel
